export default __webpack_public_path__ + "static/media/awards-player-middle.aaa752e1.png";